import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Search from "../components/Search";
import PropertiesDestaque from "../components/PropertiesDestaque";
import Footer from "../components/Footer";
import React, { useContext, useEffect } from "react";
import { InfoContext } from "../providers/InfosContextProvider";

function Home() {
  const { texts } = useContext(InfoContext);

  useEffect(() => {
    const pageTitle =
      texts?.header?.primeiro || texts?.header?.primeiro || "Início";
    document.title = `${pageTitle} | Casas do Nabão`;
  }, [texts]);
  return (
    <>
      <Header />
      <div
        className="fundo"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/fundo.jpg)`,
        }}
      >
        <Search />
        <PropertiesDestaque />
      </div>
      <Footer />
    </>
  );
}

export default Home;
